<template>
  <div>
    <div class="book" v-html="compiledMarkdown"></div>
  </div>
</template>

<script>
import marked from 'marked';

export default {
  name: 'ThoughtMarkdown',

  computed: {
    compiledMarkdown() {
      return marked(this.$store.state.currentMarkdown.markdown, { sanitize: false });
    },
  },

  mounted() {
    console.log('In Book HTTP');
    // console.log(this.$http);
    this.$store.dispatch('getLatestAutoMarkdown');
  },
};
</script>

<style lang="scss">
</style>
